// Utility functions for XeMail

// Helper to ensure dates are treated as UTC if they lack offset
const normalizeDate = (date) => {
    if (!date) return null;
    let normalized = date;
    if (typeof date === 'string' && !date.includes('Z') && !date.includes('+')) {
        normalized = date.includes('T') ? date + 'Z' : date.replace(' ', 'T') + 'Z';
    }
    return new Date(normalized);
};

export const formatDate = (date) => {
    const d = normalizeDate(date);
    if (!d) return '';
    return new Intl.DateTimeFormat([], {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    }).format(d);
};

export const formatTime = (date) => {
    const d = normalizeDate(date);
    if (!d) return '';
    return new Intl.DateTimeFormat([], {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    }).format(d);
};

export const formatLongDate = (date) => {
    const d = normalizeDate(date);
    if (!d) return '';
    return new Intl.DateTimeFormat([], {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    }).format(d);
};
